var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mainBox", staticStyle: { "padding-top": ".98rem" } },
    [
      _c("topbar", { attrs: { text: "消息" } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "infoList" },
        [
          _vm.isSystemMessage
            ? _c(
                "div",
                {
                  staticClass: "infoItem",
                  on: {
                    click: function($event) {
                      _vm.to("serviceAssistant")
                    }
                  }
                },
                [
                  _c("div", { staticClass: "icon" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "contentBox" }, [
                    _c("div", { staticClass: "notice" }, [
                      _vm._v(
                        "\n                        服务助手\n                        "
                      ),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("time")(_vm.systemMessage.createTime))
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "newsBox" }, [
                      _c("div", { staticClass: "content" }, [
                        _vm._v(_vm._s(_vm.systemMessage.content))
                      ]),
                      _vm._v(" "),
                      _vm.systemMessageCount > 0
                        ? _c("div", { staticClass: "news" }, [
                            _vm._v(_vm._s(_vm.systemMessageCount))
                          ])
                        : _vm._e()
                    ])
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.userBespeakChatList, function(item) {
            return _c(
              "div",
              {
                staticClass: "infoItem",
                on: {
                  click: function($event) {
                    _vm.to("reply?bespeakId=" + item.bespeakId)
                  }
                }
              },
              [
                _c("div", {
                  staticClass: "icon",
                  style: {
                    background:
                      "url(" +
                      _vm.EnvUrl +
                      item.photoUrl +
                      ") no-repeat center/cover"
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "contentBox" }, [
                  _c("div", { staticClass: "notice" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(item.name) +
                        "\n                        "
                    ),
                    _c("span", [
                      _vm._v(_vm._s(_vm._f("time")(item.createTime)))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "newsBox" }, [
                    _c("div", { staticClass: "content" }, [
                      _vm._v(_vm._s(item.content))
                    ]),
                    _vm._v(" "),
                    item.unRead > 0
                      ? _c("div", { staticClass: "news" }, [
                          _vm._v(_vm._s(item.unRead))
                        ])
                      : _vm._e()
                  ])
                ])
              ]
            )
          }),
          _vm._v(" "),
          _c("no-more-data", { attrs: { noMoreData: _vm.noMoreData } })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25603163", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25603163","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/news.vue
// module id = null
// module chunks = 